import { type Placement } from "react-aria";
import { CoreTooltip } from "@boi/components-core";

export const DEFAULT_OFFSET = CoreTooltip.DEFAULT_OFFSET;

export const DEFAULT_PLACEMENT = "top" satisfies Placement;
